import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import BeneficiaryAccountDetails from "../../../../containers/Accounts/BeneficiaryAccount/BeneficiaryAccountDetails";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

function BeneficiaryAccountDetailsPopup({
  closeBeneAccountDetailModal,
  bene_account_id,
  beneAccountStatus,
  type,
  showCategory,
  flow,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={
          beneAccountStatus === "pending"
            ? "Account approval pending"
            : "Beneficiary account details"
        }
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        headersubtext={
          beneAccountStatus === "pending"
            ? "Account is not approved, approve account before approving transaction."
            : undefined
        }
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${bene_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <BeneficiaryAccountDetails
          bene_account_id={bene_account_id}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
          type={type}
          servicesType="BenAdmin"
          showCategory={showCategory}
          flow={flow}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default BeneficiaryAccountDetailsPopup;
